import GuaranteeFund from './guarantee-fund';

export default GuaranteeFund;
